<template>
  <div class="order-system-container">
    <!-- 主体内容区域 -->
    <div class="main-content">
      <!-- 内容区域 -->
      <div class="content-area">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

// 从localStorage获取用户角色信息
const isAdmin = computed(() => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  return userInfo.role === 'ADMIN'
})

// 设置默认活动菜单项
const defaultRoute = computed(() => {
  return isAdmin.value ? '/admin/orders' : '/user/orders'
})

// 在组件挂载时，确保显示正确的内容
if (route.path === '/order') {
  router.replace(defaultRoute.value)
}
</script>

<style scoped>
.order-system-container {
  display: flex;
  width: 100%;
}

.main-content {
  display: flex;
  width: 100%;
  position: relative;
}

.content-area {
  width: 100%;
  padding: 20px;
  min-height: calc(100vh - 60px);
  background-color: #f9f9f9;
  overflow: auto;
  box-sizing: border-box;
}

/* 移动端响应式设计 */
@media screen and (max-width: 768px) {
  .content-area {
    padding: 10px;
  }
}
</style>